import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { AuditEvent } from 'api/giftcard-ach-service/giftcard-ach-service.types';
import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from 'components/drawers/utility-drawer/utility-drawer.component';
import EventTimeline from 'components/event-timeline/event-timeline.component';
import { mapAuditEventsToTimelineEntries } from './money-movement-transactions-events-drawer.utils';

type MoneyMovementsTransactionsEventsDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData?: { events: AuditEvent[]; id: string };
};

const MoneyMovementsTransactionsEventsDrawer = ({
  open,
  close,
  drawerData,
}: MoneyMovementsTransactionsEventsDrawerProps) => {
  const { t } = useTranslation();
  const events = drawerData?.events ?? [];

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      title={t('drawer.achTransactionsEvents.title')}
      subtitle={
        drawerData?.id && (
          <Typography
            variant="body2"
            color="text.secondary"
            data-testid="UtilityDrawer.Typography.Subtitle"
          >
            {t('drawer.achTransactionsEvents.subtitle', { id: drawerData.id })}
          </Typography>
        )
      }
      data-testid="MoneyMovementsTransactionsEventsDrawer.UtilityDrawer"
    >
      <UtilityDrawerBody>
        <EventTimeline
          title={t('drawer.achTransactionsEvents.datagrid.title')}
          data-testid="MoneyMovementsTransactionsEventsDrawer.EventTimeline"
          entries={mapAuditEventsToTimelineEntries(events, t)}
        />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default MoneyMovementsTransactionsEventsDrawer;
